import { workspaceChoiceMarkup } from './workspace-choice-control.mjs?v=20260806.100';

function escapeHtml(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

function centsInput(value) {
  const cents = Number(value || 0);
  return Number.isSafeInteger(cents) && cents >= 0 ? (cents / 100).toFixed(2) : '0.00';
}

function money(value) {
  const cents = Number(value || 0);
  const amount = Number.isSafeInteger(cents) ? cents / 100 : 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2,
  }).format(amount);
}

function activeLine(lines, lineType) {
  return (Array.isArray(lines) ? lines : []).find((line) => (
    line?.archived !== true && line?.archived_by_restore !== true && line?.line_type === lineType
  )) || null;
}

export function financeCompletionWorkspaceState({ summary = {}, lines = [] } = {}) {
  const loaded = activeLine(lines, 'loaded_pickup_cost');
  const returned = activeLine(lines, 'empty_return_cost');
  const transfer = activeLine(lines, 'transfer_cost');
  const special = activeLine(lines, 'driver_special_cost');
  return Object.freeze({
    loadedPickupCost: centsInput(loaded?.amount_cents),
    emptyReturnCost: centsInput(returned?.amount_cents),
    transferCost: centsInput(transfer?.amount_cents),
    specialAmount: special ? centsInput(special.amount_cents) : '',
    specialDate: String(special?.date || ''),
    specialName: String(special?.name_or_payee || ''),
    specialDetails: String(special?.details || ''),
    customerQuote: centsInput(summary?.customer_quote_cents),
    customerReceivable: centsInput(summary?.customer_receivable_cents),
    remittanceStatus: ['received', 'not_received'].includes(summary?.remittance_status)
      ? summary.remittance_status : 'not_received',
    operationalCost: money(summary?.total_operational_cost_cents),
    totalRevenue: money(summary?.total_revenue_cents),
    profit: money(summary?.profit_cents),
  });
}

function moneyField({ label, name, value }) {
  return `<label class="finance-workspace-field"><span>${escapeHtml(label)}</span><span class="finance-workspace-money"><i aria-hidden="true">$</i><input name="${escapeHtml(name)}" type="number" min="0" step="0.01" value="${escapeHtml(value)}" required></span><small data-field-error></small></label>`;
}

export function financeCompletionWorkspaceMarkup({ containerNo = 'Container', state = {} } = {}) {
  return `<span data-workspace-container-number hidden>${escapeHtml(containerNo)}</span>
    <form class="finance-completion-workspace" data-workspace-done-target novalidate>
      <dl class="finance-workspace-metrics" aria-label="Calculated Finance summary">
        <div><dt>Cost</dt><dd>${escapeHtml(state.operationalCost || '$0')}</dd></div>
        <div><dt>Revenue</dt><dd>${escapeHtml(state.totalRevenue || '$0')}</dd></div>
        <div class="finance-workspace-metrics__profit"><dt>Profit</dt><dd>${escapeHtml(state.profit || '$0')}</dd></div>
      </dl>
      <div class="finance-workspace-grid">
        ${moneyField({ label: 'Pickup cost', name: 'loaded_pickup_cost', value: state.loadedPickupCost || '0.00' })}
        ${moneyField({ label: 'Empty return cost', name: 'empty_return_cost', value: state.emptyReturnCost || '0.00' })}
        ${moneyField({ label: 'Transfer cost', name: 'transfer_cost', value: state.transferCost || '0.00' })}
        ${moneyField({ label: 'Driver special fee', name: 'special_amount', value: state.specialAmount || '' })}
        <label class="finance-workspace-field"><span>Special fee date</span><input name="special_date" type="date" value="${escapeHtml(state.specialDate || '')}"><small data-field-error></small></label>
        <label class="finance-workspace-field"><span>Driver / payee</span><input name="special_name" maxlength="200" value="${escapeHtml(state.specialName || '')}"><small data-field-error></small></label>
        <label class="finance-workspace-field finance-workspace-field--wide"><span>Special fee detail</span><textarea name="special_details" maxlength="2000" rows="2">${escapeHtml(state.specialDetails || '')}</textarea><small data-field-error></small></label>
        ${moneyField({ label: 'Customer quote', name: 'customer_quote', value: state.customerQuote || '0.00' })}
        ${moneyField({ label: 'Customer receivable', name: 'customer_receivable', value: state.customerReceivable || '0.00' })}
        <div class="finance-workspace-field finance-workspace-field--wide">${workspaceChoiceMarkup({
    name: 'remittance_status',
    label: 'Remittance',
    value: state.remittanceStatus || 'not_received',
    options: [
      { value: 'received', label: 'Received', tone: 'paid' },
      { value: 'not_received', label: 'Not received', tone: 'unpaid' },
    ],
  })}</div>
      </div>
      <p class="workflow-form-error" data-finance-workspace-error role="alert"></p>
    </form>`;
}
